import React from "react";
import { CellProps } from "react-table";
import AgTable from "../../../components/AgTable";
import { Log } from "../../../models";
import { DEFAULT_VALUE, FIRM_AVALABILITY_CONSTANT } from "../../../utils/constant";
import { formatDateTimeNoSecond, formatDateTimeToLocalTime } from "../../../utils/helper";
import { ISearchLogTabProps } from "./searchLogTab.props";

const SearchLogTab: React.FC<ISearchLogTabProps> = ({
  data,
  maxLength,
  entriesPerPage = DEFAULT_VALUE.ENTRIES_PER_PAGE,
  onHandleNextPage,
  pageCount,
  page = 1,
  isLoading,
  ...props
}: ISearchLogTabProps) => {
  const columns = React.useMemo(
    () => [
      {
        Header: "User",
        width: "16%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          return (
            <div className="flex flex-col items-start">
              <p className="text-[14px] text-[#58585B] font-medium m-0 p-0">{`${rowData.fkIndividual?.firstName} ${rowData.fkIndividual?.lastName}`}</p>
              <p className="text-[14px] text-[#637381] font-normal m-0 p-0">
                {rowData.fkIndividual?.individualEmailAddr}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Organization",
        width: "16%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          return <p className="">{rowData.fkIndividual?.fkOrg?.orgName}</p>;
        },
      },
      {
        Header: "Action",
        width: "8%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          return <p className="">{rowData.actionLog}</p>;
        },
      },
      {
        Header: "Search Details",
        width: "25%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          // if (rowData.inverseFkParentLogs?.length) {
          //   const checkIsSearchOfSearch =
          //     rowData.searchMainServiceLogs?.length ||
          //     rowData.searchSecondaryServiceLogs?.length ||
          //     rowData.acceptingClients ||
          //     rowData.willingOfferAdvice ||
          //     rowData.loanStaff ||
          //     rowData.receiveStaff ||
          //     rowData.globalOpportunities ||
          //     rowData.keywork ||
          //     rowData.industry
          //       ? true
          //       : false;

          //   textSearhcDetails = checkIsSearchOfSearch
          //     ? rowData.mainServiceLogs?.map((e) => e.mainServiceName).join(", ")
          //     : rowData.inverseFkParentLogs?.map((e) => e.fkFirm?.firmName1).join(", ");
          // } else {}
          
          let textSearhcDetails = [
            ...(rowData.searchMainServiceLogs?.map((e) => e.mainServiceName) ?? []),
            ...(rowData.searchSecondaryServiceLogs?.map((e) => e.secondaryServiceName) ?? []),
            rowData.acceptingClients && FIRM_AVALABILITY_CONSTANT.ACCEPTING_CLIENT,
            rowData.willingOfferAdvice && FIRM_AVALABILITY_CONSTANT.OFFER,
            rowData.loanStaff && FIRM_AVALABILITY_CONSTANT.SHARE_TALENT,
            rowData.receiveStaff && FIRM_AVALABILITY_CONSTANT.HOST_SHARE_TALENT,
            rowData.globalOpportunities && FIRM_AVALABILITY_CONSTANT.OFFER_OPPORTUNITIES,
            rowData.keywork,
            rowData.firmName,
            rowData.orgTypeIds,
            rowData.interestTypeIds,
            ...(rowData.searchRegionLogs?.map((e) => e.netRegionName) ?? []),
            rowData.industry,
          ]
            .filter((e) => !!e)
            .join("; ");

          return <p className="">{textSearhcDetails}</p>;
        },
      },
      {
        Header: "Results",
        width: "5%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          return <p className="">{rowData?.inverseFkParentLogs?.length ?? 0}</p>;
        },
      },
      {
        Header: "Time stamp",
        width: "14%",
        Cell: ({cell, row}: CellProps<Log, any>) => {
          const rowData = row.original;

          return <p className="">{ formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.createdAt))}</p>;
        },
      },
    ],
    [],
  );

  return (
    <AgTable
      columns={columns}
      data={data}
      maxLength={maxLength}
      entriesPerPage={entriesPerPage}
      onHandleNextPage={onHandleNextPage}
      page={page}
      pageCount={pageCount}
      isLoading={isLoading}
    />
  );
};

export default React.memo(SearchLogTab);
